import type { ContactSearchEntry } from "app/pages/sales-intelligence/sub-modules/contacts-search/types/common";
import type { RevealedContactDto } from "app/pages/sales-intelligence/sub-modules/contacts-search/types/dto";
import { isRevealedContactSearchEntryType } from "app/pages/sales-intelligence/sub-modules/contacts-search/utils/type-guards";

function getContactPrivateData(contact: ContactSearchEntry): RevealedContactDto | undefined {
    if (!isRevealedContactSearchEntryType(contact) || !contact.privateData) {
        return undefined;
    }

    return contact.privateData;
}

export default getContactPrivateData;
